import { Pipe, PipeTransform } from '@angular/core';
import { TaskLocation } from '@interfaces/location/task-location';
import { environment } from 'src/environments/environment';

@Pipe({
  name: 'extractNameFromLocation',
  standalone: true,
})
export class ExtractNameFromLocationPipe implements PipeTransform {
  isWlmhEnabled = environment.isWlmhEnabled;
  transform(input: TaskLocation | string): string {
    if (typeof input === 'string') {
      return input;
    }

    const { floor, name, department, unit } = input;

    if (this.isWlmhEnabled) {
      return `${floor}, ${name} - ${department} / ${unit}`;
    } else {
      return name;
    }
  }
}
